<template>
  <div class="order-pay">
    <div>
      <form
        ref="form"
        name="payForm"
        method="post"
        :action="urlPd"
      />
    </div>
    <div class="order-header">
      {{ $route.query.payType == 'paypal' ? 'PayPal支付' : '銀行轉賬' }}
    </div>
    <div class="order-main">
      <!-- <el-tabs v-model="active" @tab-click="handleClick"> -->
      <!-- <el-tab-pane label="信用卡" name="credit">
                    <button class="buttonPD" @click="submitCre">信用卡</button>
                    <p class="pPD">技術支持提供方：PayDollar</p>
                    <iframe :src="urlPd" frameBorder="0" width="900" scrolling="no" height="900"></iframe>
                </el-tab-pane> -->
      <!-- <el-tab-pane label="PayPal" name="paypal"> -->
      <div v-show="$route.query.payType == 'paypal'">
        <div class="pay-paypal" />
      </div>
      <!-- </el-tab-pane> -->
      <!-- <el-tab-pane label="銀行轉賬" name="bank"> -->
      <div v-if="$route.query.payType == 'transfer'">
        <p>你可透過ATM轉賬或銀行櫃台入數到以下戶口：</p>
        <table
          class="table_nobor"
          style="margin: 30px 0; width: 880px"
        >
          <tr height="100">
            <td
              align="left"
              width="250"
            >
              <img
                src="../../assets/chinabank.jpg"
                alt
                width="200"
              >
            </td>
            <td align="left">
              <p>
                中銀香港(代碼：012)：875-2-035677-8
                <br>賬戶名稱：HOUSE730 LIMITED
              </p>
            </td>
          </tr>
          <tr height="10">
            <td
              align="left"
              width="280"
            >
              <img
                src="../../assets/hangsengbank.jpg"
                alt
                width="200"
              >
            </td>
            <td align="left">
              <p>
                恒生银行(代碼：024)：752-007526-883
                <br>賬戶名稱：HOUSE730 LIMITED
              </p>
            </td>
          </tr>
          <tr height="10">
            <td
              align="left"
              width="280"
            >
              <img
                src="../../assets/hsbc_logo.png"
                alt
                width="200"
              >
            </td>
            <td align="left">
              <p>
                滙豐銀行 (代碼：004)：023-786478-838
                <br>賬戶名稱：HOUSE730 LIMITED
              </p>
            </td>
          </tr>
          <tr height="80">
            <td
              align="left"
              width="280"
            >
              <img
                src="../../assets/PMS_FPS.png"
                alt
                width="200"
              >
            </td>
            <td align="left">
              <p>
                FPS轉數快系統識別碼：3575503
                <br>賬戶名稱：HOUSE730 LIMITED
              </p>
            </td>
          </tr>
        </table>

        <p class="lineB f13">
          轉賬後，請在入數紙寫上你的手提電話/訂單編號，並用以下其中一個方法通知我們：
        </p>
        <p class="lineB f13">
          (1) 傳真：852-3619 3201。
        </p>
        <p class="lineB f13">
          (2) WhatsApp：852-5726 6308。
        </p>
        <p
          class="lineB f13"
          style="margin-bottom: 25px"
        >
          (3) 電郵：support@house730.com ，電郵標題請註明：“payment to House730”。
        </p>
        <p class="lineB f13">
          一般情況下，我們會在下一個工作天內更新會員帳號及樓盤的相關資料。
        </p>
      </div>
      <!-- </el-tab-pane> -->
      <!-- </el-tabs> -->
    </div>
    <el-button
      type="info"
      class="returnBut"
      @click="returnOrder"
    >
      返回訂單詳情
    </el-button>
    <el-button
      v-if="$route.query.payType == 'transfer'"
      type="info"
      class="returnBut"
      @click="returnManage"
    >
      返回訂單管理
    </el-button>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <span>
        <i class="el-icon-warning" />
        {{ `您的訂單將於${expireTime}後到期，請即付款!` }}
      </span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >立即付款</el-button>
        <div class="pay-now-btn" />
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="payVisible"
      width="400px"
    >
      <span>
        <i class="el-icon-warning" />
        {{ `您的訂單將於${expireTime}後到期，請即付款!` }}
      </span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="payDagain"
        >立即付款</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog class="conPdia" width="30%" :visible.sync="confirmPay" :close-on-click-modal="false" :close-on-press-escape="false" center :show-close="false">
            <div style="text-align: center"><img src="../../assets/dollarlink.gif" alt="##" /></div>
            <div style="text-align: center">即將轉換到第三方的信用卡付款頁面</div>
            <div style="text-align: center"><img src="../../assets/dollarello.gif" alt="##" /></div>
        </el-dialog> -->
  </div>
</template>
<script>
export default {
    name: 'OrderDetail',
    data() {
        return {
            confirmPay: false,
            paycode: '',
            urlPd: '',
            active: 'credit',
            orderid: this.$route.query.orderId || this.$route.query.Ref,
            backUrl: this.$route.query.backUrl,
            expireTime: this.$route.query.expireTime || localStorage.getItem('saveExptime'),
            dialogVisible: false,
            payVisible: false,
            paytype: this.$route.query.paytype || ''
            // isfirst: true
        };
    },
    mounted() {
        if (!this.orderid && this.active == 'paypal') {
            this.$message({
                message: '訂單號碼不存在',
                type: 'error',
                showClose: true
            });
        } else {
            if (this.orderid && this.active == 'paypal') {
                document.querySelector('.pay-paypal').style.minHeight = '200px';
                document.querySelector('.pay-paypal').style.overflow = 'auto';
            }
            if (typeof paypal === 'undefined') {
                this.loadPaypal();
            } else {
                this.initPay('.pay-paypal');
                this.initPay('.pay-now-btn', true);
            }
            //判断paypal SDK是否已加载
            // typeof paypal === 'undefined' ? this.loadPaypal() : (this.initPay('.pay-paypal'), this.initPay('.pay-now-btn', true));
            this.axios
                .get(this.pub.getApi().GetOrderRecord, {
                    params: { orderId: this.orderid }
                })
                .then(res => {
                    if (res.data.result) {
                        this.order = res.data.result;
                        if (this.order.orderStatus === 1) {
                            this.$message({
                                message: '訂單已付款',
                                type: 'info',
                                showClose: true
                            });
                            this.$router.push(this.backUrl);
                        } else {
                        } //此订单已经付款
                    } else {
                        this.$message({
                            message: '交易失敗!',
                            type: 'error',
                            showClose: true
                        }); //"交易失敗，請聯繫管理員"
                    }
                });
        }
        if (this.paytype == 'fail') {
            this.$message({
                message: '交易失敗!!',
                type: 'error',
                showClose: true
            });
        }
        if (this.paytype == 'cancel') {
            this.payVisible = true;
        }
    },
    methods: {
        returnManage() {
            this.$router.push('/order/index');
        },
        returnOrder() {
            this.$router.push({
                path: '/coin/order-detail',
                query: {
                    orderId: this.$route.query.orderId,
                    paymentType: this.$route.query.payType == 'paypal' ? 9 : 10
                }
            });
        },
        payDagain() {
            this.payVisible = false;
            this.submitCre();
        },
        async submitCre() {
            let _this = this;
            await _this.axios
                .post(_this.pub.getApi().CreatePayDollarOrder, {
                    orderID: _this.orderid,
                    platformType: 'pc'
                })
                .then(res => {
                    this.paycode = res.data.code;
                    if (res.data.code == 0) {
                        _this.urlPd = res.data.result;
                    } else {
                        _this.$message({
                            message: '訂單狀態不正確，請重試！',
                            type: 'warning',
                            showClose: true
                        });
                    }
                });
            // var width = 504;
            // var height = 482;
            // var iTop = (window.screen.height - 30 - height) / 2;
            // var iLeft = (window.screen.width - 10 - width) / 2;
            // 先弹窗 3s后paydollar
            this.confirmPay = true;
            setTimeout(() => {
                this.confirmPay = false;
                if (this.paycode == 0) {
                    _this.$refs.form.submit();
                    // window.open(_this.urlPd, '', 'width=' + width + ',height=' + height + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,status=no,menubar=no,resizable=yes,scrollbars=yes');
                }
            }, 3000);
            // window.open(_this.urlPd, '_blank', );
        },
        handleClick() {},
        //加载paypal
        loadPaypal() {
            let payScript = document.createElement('script');
            payScript.type = 'text/javascript';
            payScript.src = this.pub.config.paypalSdk;
            document.body.appendChild(payScript);
            payScript.onload = () => {
                this.initPay('.pay-paypal');
                this.initPay('.pay-now-btn', true);
            };
        },
        //初始化支付
        initPay(btnContainer, again = false) {
            // console.log('init')
            let _this = this;
            paypal
            // eslint-disable-next-line new-cap
                .Buttons({
                    style: {
                        color: 'blue',
                        shape: 'rect',
                        label: 'paypal',
                        layout: again ? 'horizontal' : 'vertical',
                        height: again ? 38 : 55
                    },
                    //创建支付订单
                    createOrder: function () {
                        _this.dialogVisible = false;
                        return _this.axios
                            .post(_this.pub.getApi().CreatePaypalOrder, {
                                orderID: _this.orderid
                            })
                            .then(res => {
                                // console.log("created", res);
                                if (res.data.code === 0) {return res.data.result;}
                                else if (res.data.code === 1712) {
                                    _this.$message({
                                        message: '該訂單已過期，請重新購買！',
                                        type: 'warning',
                                        showClose: true
                                    });
                                } else {
                                    _this.$message({
                                        message: '訂單狀態不正確，請重試！',
                                        type: 'warning',
                                        showClose: true
                                    });
                                }
                            });
                    },
                    //订单支付回调 成功 || 失败
                    onApprove: function (a, n) {
                        const loading = _this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        return _this.axios
                            .post(_this.pub.getApi().CapturePaypalOrder, {
                                orderID: _this.orderid,
                                paypalOrderID: a.orderID
                            })
                            .then(res => {
                                loading.close();
                                // console.log("approve", res);
                                if (res.data.code === 0) {
                                    _this.$message({
                                        message: '支付成功',
                                        type: 'success',
                                        showClose: true
                                    });
                                    _this.$router.push(_this.backUrl);
                                } else {
                                    _this.$message({
                                        message: `支付失敗${res.data.message}`,
                                        type: 'error',
                                        showClose: true
                                    });
                                }
                            });
                        setTimeout(() => loading.close(), 20000);
                    },
                    //用户取消操作回调 交易取消
                    onCancel: function (a) {
                        // _this.$message({
                        //     message: '交易取消',
                        //     type: 'info',
                        //     showClose: true
                        // });
                        _this.showTips();
                    },
                    //交易异常回调 交易失敗，請聯繫管理員
                    onError: function (a, n) {
                        // this.$dialog.alert({
                        //   title: _this.lang.tip,
                        //   message: _this.lang.dealCancel,
                        //   confirmButtonText: _this.lang.confirm
                        // });
                        _this.$message({
                            message: '交易失敗!!',
                            type: 'error',
                            showClose: true
                        });
                    }
                })
                .render(btnContainer);
        },
        showTips() {
            this.dialogVisible = true;
            // if (this.isfirst) {
            //     this.isfirst = false;
            //     this.initPay('.pay-now-btn', true);
            //     // this.$nextTick(() => {});
            // }
        },
        // 支付成功后，返回
        back() {}
    },
    beforeRouteLeave(to, from, next) {
        document.querySelector('.pay-paypal').style.height = 'initial';
        document.querySelector('.pay-paypal').style.overflow = 'initial';
        next();
    }
};
</script>
<style lang="less" scoped>
@import url('../../assets/css/element-reset');
.order-pay {
    text-align: left;
    // padding-left: 20px;
    .order-header {
        font-size: 24px;
        margin-bottom: 24px;
        color: #171725;
    }
    .returnBut {
        border-radius: 12px;
        margin-top: 15px;
    }
    .order-main {
        background-color: #fff;
        padding: 15px;
        border-radius: 10px;
        .buttonPD {
            background-color: #0070ba;
            color: #ffffff;
            font-size: 24px;
            width: 750px;
            height: 55px;
            border: none;
            border-radius: 7px;
            cursor: pointer;
        }
        .pPD {
            font-size: 16px;
            color: #696974;
            margin-left: 279px;
            margin-top: 10px;
        }
    }
    .conPdia {
        text-align: center;
        /deep/.el-dialog__header {
            display: none;
        }
    }
    .el-tabs {
        /deep/.el-tabs__content {
            overflow: visible;
        }
    }
    .el-dialog__wrapper {
        .el-icon-warning {
            color: #e6a23c;
            font-size: 24px;
            position: relative;
            top: 3px;
            margin-right: 5px;
        }
        /deep/.el-dialog__body {
            padding: 15px 20px;
        }
        /deep/.el-dialog__footer {
            position: relative;
            .pay-now-btn {
                width: 98px;
                height: 38px;
                overflow: hidden;
                position: absolute;
                right: 20px;
                top: 10px;
                opacity: 0.01;
            }
        }
    }
}
</style>
